import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withTranslation } from "react-i18next";
import { withStyles, Slide } from "@material-ui/core";
import { showVerificationScreen } from "../actions/index";
import { CheckCircle, CheckCircleOutlined } from "@material-ui/icons";
import {
  submitVerificationCode,
  resendVerificationCode,
  pushNotification,
} from "../actions/index";

import { images } from "../utils/images";
import { CheckCircleOutline } from "@material-ui/icons";
import Loader from "../components/Loader";
import * as Auth from "../utils/auth";

const urlSolo = (
  process.env.NODE_ENV === "production" ? window.SOLO.env : process.env
).REACT_APP_DASHBOARD;

function VerificationScreen(props) {
  const {
    classes,
    t,
    continueVerification,
    account,
    emailCodeResent,
    emailVerificationError,
  } = props;

  const [codeResent, setCodeResent] = useState(false);
  const [verificationCode, setVerificationCode] = useState("");
  const [firstRequest, setFirstRequestMade] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(function () {
    if (continueVerification) {
      props.history.push("/id/upgrade");
    }

    setTimeout(() => {
      setLoading(false);
    }, 1000);

    document.body.style.background = "#262626";

    return () => {
      document.body.style.background = "#262626";
    };
  }, []);

  useEffect(() => {
    if (emailCodeResent.codeSent) {
      setCodeResent(true);
    }

    if (emailCodeResent.error) {
      if (!firstRequest) {
        props.pushNotification({
          message: "wait5minutes",
          type: "error",
        });
      }
    }
  }, [emailCodeResent]);

  useEffect(() => {
    if (account.account !== null) {
      if (account.account.level === 0 && !loading) {
        setFirstRequestMade(true);
        let obj = {
          email: account.account.email,
        };
        props.resendVerificationCode(obj);
      }
    }
  }, [account]);

  const submitCode = async () => {
    const email = account.account.email;

    props.submitVerificationCode({
      email,
      confirmation_code: verificationCode.trim(),
    });
  };

  const resendEmail = () => {
    setFirstRequestMade(false);
    let obj = {
      email: account.account.email,
    };
    props.resendVerificationCode(obj);
  };

  if (account.account === null || loading) {
    return (
      <div className={classes.signUpContainer}>
        <div className={classes.soloLogo}>
          <img src={images.logos.sologenicWhiteLogo} />
        </div>
        <div style={{ marginTop: 24 }}>
          <Loader />
        </div>
      </div>
    );
  }

  if (account.account.level === 0) {
    return (
      <div className={classes.signUpContainer}>
        <div className={classes.soloLogo}>
          <img
            src={images.logos.sologenicWhiteLogo}
            onClick={() => (window.location.href = urlSolo)}
          />
        </div>
        <Slide in direction="left">
          <div className="verifyEmail singleContainer">
            <h1>{t("checkInbox")}</h1>
            <p
              dangerouslySetInnerHTML={{
                __html: t("verificationNotice", {
                  user_email: account.account.email,
                  // user_email: "email@email.com",
                }),
              }}
            />
            <input
              type="text"
              onChange={(e) => setVerificationCode(e.target.value)}
              placeholder={t("enterVerificationCode")}
            />
            {emailVerificationError ? (
              <p
                className="passRequirements notMatch"
                style={
                  emailVerificationError
                    ? { height: "auto", marginBottom: 16 }
                    : { height: 0, overflow: "hidden" }
                }
              >
                <img src={images.icons.error} />
                {t(emailVerificationError)}
              </p>
            ) : (
              ""
            )}
            {/* <ReCAPTCHA
                 ref={captchaRef}
                 sitekey={sitekey}
                 theme="dark"
                 size="invisible"
               /> */}
            <button
              onClick={() => submitCode()}
              disabled={verificationCode === "" ? true : false}
            >
              {t("verify")}
            </button>

            {/* {firstRequest ? (
              <span onClick={() => resendEmail()}>{t("noEmailReceived")}</span>
            ) : (
              "'"
            )} */}
            {codeResent && !firstRequest ? (
              <p className={classes.codeSent}>
                {t("codeSentEmail")} <CheckCircleOutline />
              </p>
            ) : (
              <span onClick={() => resendEmail()}>{t("noEmailReceived")}</span>
            )}
            <img className="img" src={images.illustrations.envelopeSolo} />
          </div>
        </Slide>
      </div>
    );
  }

  return (
    <div className={classes.verificationScreen}>
      <div className={classes.soloLogo}>
        <img
          src={images.logos.sologenicWhiteLogo}
          onClick={() => (window.location.href = urlSolo)}
        />
      </div>
      <h1>{t("starterAccountApprovedS")}</h1>
      <div className="verificationWrappers">
        <div className="startTradingWrapper levelWrapper">
          <div className="wrapperHeader">
            <p>{t("startUnlocked")}</p>
          </div>
          <div className="wrapperBody">
            <ul>
              <li>
                <CheckCircleOutlined /> <p>{t("unlock1S")}</p>
              </li>
              <li>
                <CheckCircleOutlined /> <p>{t("unlock2S")}</p>
              </li>
              <li>
                <CheckCircleOutlined /> <p>{t("unlock3S")}</p>
              </li>
              <li>
                <CheckCircleOutlined /> <p>{t("unlock4S")}</p>
              </li>
              <li>
                <CheckCircleOutlined /> <p>{t("unlock5S")}</p>
              </li>
            </ul>
            <button
              className="startTradeBtn"
              onClick={() => Auth.redirectToDashboard()}
            >
              {t("goToDashboard").toUpperCase()}
            </button>
          </div>
        </div>
        <div className="upgradeAccWrapper levelWrapper">
          <div className="wrapperHeader">
            <p>{t("upgradeToUnlockS")}</p>
          </div>
          <div className="wrapperBody">
            <ul>
              <li>
                <CheckCircleOutlined /> <p>{t("proUnlock1S")}</p>
              </li>
              <li>
                <CheckCircleOutlined /> <p>{t("proUnlock2S")}</p>
              </li>
              <li>
                <CheckCircleOutlined /> <p>{t("proUnlock3S")}</p>
              </li>
              <li>
                <CheckCircleOutlined /> <p>{t("proUnlock4S")}</p>
              </li>
              <li>
                <CheckCircleOutlined /> <p>{t("proUnlock5S")}</p>
              </li>
            </ul>

            <p className="comingSoon">{t("_comingSoon")}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    continueVerification: state.continueVerification,
    account: state.account,
    verificationResponse: state.verificationResponse,
    emailVerificationError: state.emailVerificationError,
    emailCodeResent: state.emailCodeResent,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      showVerificationScreen,
      submitVerificationCode,
      resendVerificationCode,
      pushNotification,
    },
    dispatch
  );
}

const styles = (theme) => ({
  soloLogo: {
    width: "100%",
    height: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    position: "relative",
    "& img": {
      width: 180,
      height: "auto",
    },
  },
  verificationScreen: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    color: theme.colors.text.primary,

    "& img": {
      width: 220,
      height: "auto",
      marginTop: 40,
    },

    "& h1": {
      fontSize: 32,
      fontFamily: "Roboto, sans-serif",
      fontWeight: 600,
      margin: "80px 0",
      textAlign: "center",
      color: theme.colors.text.textOnRed,
    },

    "& .verificationWrappers": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "row-reverse",
      [theme.breakpoints.down(800)]: {
        flexDirection: "column",
        marginBottom: 24,
      },

      "& .startTradingWrapper": {
        background: theme.colors.background.fore,
        boxShadow: "-4px 0 16px #00000040",
        borderRadius: 8,
        borderBottomLeftRadius: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        [theme.breakpoints.down(800)]: {
          borderBottomLeftRadius: 0,
          borderTopRightRadius: 8,
        },
        "& .wrapperHeader": {
          background: theme.colors.background.lightFore,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: 80,
          width: "100%",
          borderTopRightRadius: 8,
          [theme.breakpoints.down(800)]: {
            borderTopRightRadius: 8,
          },

          "& p": {
            fontSize: 24,
            fontFamily: "Dm Sans, sans-serif",
          },
        },
        "& .wrapperBody": {
          padding: "32px 40px 32px 72px",

          [theme.breakpoints.down(450)]: {
            padding: 12,
          },

          "& ul": {
            "& li": {
              display: "flex",
              alignItems: "center",
              fontSize: 18,
              marginBottom: 12,
              // fontFamily: "Titillium Web",
              lineHeight: "24px",

              "& svg": {
                marginRight: 8,
                color: theme.colors.buttons.green,
              },
            },
          },

          "& button": theme.defaults.squareBtn,
          "& .startTradeBtn": {
            width: "100%",
            marginTop: 32,
            background: theme.colors.buttons.green,
            // background: "transparent",
            // borderColor: theme.colors.buttons.green,
            color: theme.colors.text.textOnRed,
          },
        },
      },
      "& .upgradeAccWrapper": {
        background: theme.colors.background.fore,
        borderRadius: 8,
        boxShadow: "-4px 0 16px #00000040",
        display: "flex",
        flexDirection: "column",
        "& .wrapperHeader": {
          background: theme.colors.background.verificationHeader,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: 80,
          width: "100%",
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,

          "& p": {
            fontSize: 24,
            fontFamily: "Dm Sans, sans-serif",
            textAlign: "center",
            color: theme.colors.text.textOnRed,
          },
        },

        "& .wrapperBody": {
          padding: "32px 72px",

          [theme.breakpoints.down(450)]: {
            padding: 12,
          },

          "& ul": {
            "& li": {
              display: "flex",
              alignItems: "center",
              fontSize: 20,
              marginBottom: 12,
              lineHeight: "24px",

              // fontFamily: "Titillium Web",

              "& svg": {
                marginRight: 8,
                color: theme.colors.misc.activeDoc,
              },
            },
          },

          "& button": theme.defaults.squareBtn,
          "& .upgradeBtn": {
            width: "100%",
            background: theme.colors.background.active,
            marginTop: 80,
            color: theme.colors.text.textOnRed,
          },
          "& .comingSoon": {
            textAlign: "center",
            fontWeight: 600,
            fontSize: 24,
            marginTop: 100,
            color: theme.colors.text.secondary,
          },

          "& .infoReq": {
            textAlign: "center",
            fontSize: 12,
            margin: "12px auto 0",
            // fontFamily: "Titillium Web",
            lineHeight: "16px",
            color: theme.colors.text.secondary,
            "& b": {
              color: theme.colors.text.primary,
            },
          },
        },
      },
    },
  },
  codeSent: {
    fontSize: "18px !important",
    // fontFamily: "Titillium Web",
    color: theme.colors.text.secondary,
    display: "flex",
    alignItems: "center",
    "& svg": {
      marginLeft: 5,
      color: theme.colors.buttons.buy,
    },
  },
  signUpContainer: {
    color: theme.colors.text.primary,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: 80,
    "& .verifyEmail": {
      display: "flex",
      flexDirection: "column",
      maxWidth: 880,
      width: "95%",
      overflow: "hidden",
      position: "relative",
      background: theme.colors.background.fore,
      padding: "40px 200px 40px 80px",
      justifyContent: "space-between",
      marginTop: 42,

      [theme.breakpoints.down(600)]: {
        padding: 24,
      },
      "& input": {
        ...theme.defaults.input,
        marginBottom: 8,
      },
      "& .passRequirements": {
        fontSize: 14,
        // fontFamily: "Titillium Web",
        lineHeight: "21px",
        color: theme.colors.text.secondary,
        display: "flex",
        "& img": {
          width: 12,
          height: 12,
          marginRight: 6,
          marginTop: 4,
        },

        "&.notMatch": {
          "& img": {
            width: 16,
            height: 16,
            marginRight: 6,
            marginTop: 0,
            position: "relative",
          },
        },
      },
      "& button": {
        ...theme.defaults.roundBtn,
        marginTop: 8,
        marginBottom: 12,
        width: "100%",
        maxWidth: 320,
        background: theme.colors.buttons.green,
      },
      "& .img": {
        position: "absolute",
        right: 0,
        top: 0,
        height: "130%",
        width: "auto",
        transform: "translate(35%, -12%)",
        [theme.breakpoints.down(600)]: {
          display: "none",
        },
      },
      "& h1": {
        fontSize: 28,
        fontWeight: 600,
      },
      "& p": {
        color: theme.colors.text.secondary,
        marginBottom: 16,
        marginTop: 8,
        lineHeight: "21px",
        fontSize: 14,
        // fontFamily: "Titillium Web",
        width: "70%",
        "& b": {
          color: theme.colors.text.primary,
        },
      },
      "& span": {
        fontSize: 18,
        textDecoration: "underline",
        transition: ".3s",
        cursor: "pointer",
        // fontFamily: "Titillium Web",
        "&:hover": {
          opacity: 0.5,
        },
      },
    },
  },
});

export default withStyles(styles)(
  withTranslation()(
    connect(mapStateToProps, mapDispatchToProps)(VerificationScreen)
  )
);
